<div class="inspections-container">
  <div class="top-container">
    <app-common-filterbuilder-staff-janus
      [placeholder]="'Search Inspections'"
      (search)="onSearch($event)"
      (attributeSelect)="onAttribute($event)"
      [attributeOptions]="inspectionAttributes"
      [myWorkOptions]="myWorkOptions"
      (filterChanged)="onFilterChanged($event)"
      [useMuiLayout]="true"
      [id]="'inspections-janus-table'"
      [externalFilterInputs]="filterInputs"
      (externalFilterInputsChange)="onExternalFiltersChanged($event)"
      [customTemplate]="exportsButtonTemplate"
      [local_storage_key]="FILTER_CACHE_KEY"
    >
    </app-common-filterbuilder-staff-janus>

    <!-- Added by Vipul on 10/03/2026 -->
    <ng-template #exportsButtonTemplate>
        <app-scheduled-exports-janus
          [componentId]="id"
          [title]="title"
          [params]="inspectionAttributes"
          [currentFilters]="currentFiltersForExport"
          [currentColumnOptions]="columnOptions"
          [separateDropdown]="false"
          (exportExcel)="exportExcel()"
          (exportCsv)="exportCsv()"
          [routePath]="activeTab=== 'queue' ? 'list/scheduled-export' : 'assignedInspections/scheduled-export'"
      ></app-scheduled-exports-janus>
    </ng-template>
  <!-- End by Vipul on 10/03/2026 -->

  </div>

  <div class="tabs-header">

    <div
      class="tab-item"
      routerLink="list"
      routerLinkActive="active">
      Inspections Queue
    </div>

    <div
      class="tab-item"
      routerLink="assignedInspections"
      routerLinkActive="active">
      Assigned Inspections
    </div>

  </div>

  <div class="table-scroll-container">

    <router-outlet name="overlay"></router-outlet>
    <div class="fade-in">
      <router-outlet></router-outlet>
    </div>

  </div>
</div>
